import { useEffect, type RefObject } from "react";
import { useStoreApi } from "reactflow";

/** Below this zoom a card's name row is too small to read or aim at, so it hides and the artwork carries the overview. */
export const NAME_ZOOM_FLOOR = 0.4;

/** Set on the canvas container while the zoom is below `NAME_ZOOM_FLOOR`. */
export const NAMES_OFF_ATTR = "data-names-off";

/**
 * Marks the container while the camera is past the name floor. Mount inside `<ReactFlow>`.
 * The attribute changes only when the zoom crosses the floor, so a pinch restyles the cards once, not on every frame.
 */
export function CanvasNameFloor({
  container,
}: {
  container: RefObject<HTMLElement>;
}) {
  const store = useStoreApi();
  useEffect(() => {
    const mark = (zoom: number) =>
      container.current?.toggleAttribute(
        NAMES_OFF_ATTR,
        zoom < NAME_ZOOM_FLOOR,
      );
    mark(store.getState().transform[2]);
    return store.subscribe((state, previous) => {
      const zoom = state.transform[2];
      if (zoom < NAME_ZOOM_FLOOR !== previous.transform[2] < NAME_ZOOM_FLOOR)
        mark(zoom);
    });
  }, [store, container]);
  return null;
}
